import React from "react";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import {Dayjs} from "dayjs";
import {useTheme} from "../../../contexts/theme";
import Box from "@mui/material/Box";
import TextinputField from "../TextInputField/TextinputField";
import {TextField} from "@mui/material";

interface StyledDataTimePickerProps {
    label: string;
    onChange: (value: Dayjs | null) => void;
    borderColor?: string;
    borderFocusColor?: string;
    paddingTop?: string;
    value?: Dayjs | null;
    maxDateTime?: Dayjs;
    minDateTime?: Dayjs;
}


const StyledDataTimePicker: React.FC<StyledDataTimePickerProps> = ({label,onChange, borderColor, borderFocusColor, paddingTop, value, minDateTime, maxDateTime}) => {
    const theme = useTheme();
    return (

        <DateTimePicker
            label={label}
            value={value}
            onChange={onChange}
            ampm={false}
            maxDateTime={maxDateTime}
            minDateTime={minDateTime}
            format={theme.dateFormat.datePicker}
            sx={{
                paddingTop: paddingTop,
                '& .MuiOutlinedInput-root': {
                    color: theme.palette.white,
                    '& fieldset': {
                        borderColor: borderColor,
                    },
                    '&:hover fieldset': {
                        borderColor: borderFocusColor,
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: borderFocusColor,
                        color: borderFocusColor,
                    },
                },
                '& .MuiInputBase-input': { color: theme.palette.white + ' !important' }, // Change text color
                '& .MuiInputLabel-root': {
                    color: borderColor, // Colore normale dell'etichetta
                    paddingTop: paddingTop,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                    color: borderFocusColor, // Colore dell'etichetta quando è in focus
                },
            }}
            slotProps={{
                openPickerButton: {
                    sx: {
                        color: theme.palette.lightGrey
                    }
                }
            }}

        />

    );
}
export default StyledDataTimePicker;